import customEvent from './custom-event';
/*
 * Logs an error event.
 * https://github.com/NerdWallet/schemas/blob/master/protobuf/docs/docs.md#ErrorEvent
 *
 * @param {Object{}} [options]
 * @param {string} [options.message] - Error message/headline
 * @param {string} [options.code] - Arbitrary error code associated with the error
 * @param {string} [options.type] - Ex. SecurityError, TimeoutError
 * @param {string} [options.additionalData] - Additional data; must be JSON encoded and not contain
    nested objects
 */

export default function errorEvent(options) {
  customEvent('ERROR_EVENT', null, options);
}